import "./AboutUsStyles.css";

function AboutUs() {
  return (
    <div className="about-container">
      <h1>Our history</h1>
      <p>
        Nurtured from the seed of a single idea ‘to empower the traveller with
        easy & instant travel bookings providing comprehensive choices’,
        takeatrip is a pioneer in India’s online travel space. Founded by Deep
        Kalra in the year 2000, takeatrip began its journey by serving the
        US-India travel market with best-value products & services, powered by
        robust technology and round-the-clock customer support.
      </p>

      <h1>Our Mission</h1>
      <p>
        Founded by Deep Kalra in the year 2000, takeatrip began its journey by
        serving the US-India travel market with best-value products & services,
        powered by robust technology and round-the-clock customer support.
      </p>

      <h1>Our Vision</h1>
      <p>
        Nurtured from the seed of a single idea ‘to empower the traveller with
        easy & instant travel bookings providing comprehensive choices’,
        takeatrip is a pioneer in India’s online travel space.{" "}
      </p>
    </div>
  );
}

export default AboutUs;
